/** @jsx isolateComponent */
import { css } from '@emotion/core';

import { Colors, Typography } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { rebrandFocusCss } from '../../../styles';

const skipCss = css`
  width: 100%;
  border: 1px solid ${Colors.neutral400};
  background-color: ${Colors.neutral200};
  border-radius: 5px;
  padding: 15px;
  ${Typography.smallPrint1Semibold}
  color: ${Colors.neutral800};
  ${rebrandFocusCss}
  &:hover,
  &:focus {
    background-color: ${Colors.blue10};
    border-color: ${Colors.blue10};
    color: ${Colors.blue};
  }
`;

type SkipButtonProps = {
  /** Text to display */
  children: string;
  /** Function that will be called with `null` on click */
  onSelect: (item: null) => void;
};

/** Button as used in `<AppBlock>` and `<ZapBlock>` to skip the question. */
const SkipButton = ({ children, onSelect }: SkipButtonProps) => {
  return (
    <button css={skipCss} onClick={() => onSelect(null)}>
      {children}
    </button>
  );
};

export default SkipButton;
